export default {
  title: 'Jouw bestelling',
  price: 'Prijs:',
  total: 'Totaal:',
  pay: 'Betalen',
  back: 'Terug',
  areYouSure: 'Weet je zeker dat je dit item wilt verwijderen?',
};
